import React from "react";
import "./projects.css";
import { HiExternalLink } from "react-icons/hi";
import { BsGithub } from "react-icons/bs";

const Project = ({ data}) => {
    return (
        <div className="app__project">
            <div className="app__project-overlay" />
            <div className="app__project-imgbox">
                <img src={data.img_url} alt={data.title} />
            </div>
            <div className="app__project-content d-flex gap-2 flex-item-between">
                <div className="app__project-iconbox d-flex flex-item-right gap-1">
                    { data.website_link && <div className="app__project-icon d-flex flex-item-center">
                        <a href={data.website_link} target="_blank" rel="noreferrer">
                            <HiExternalLink color="#fff" />
                        </a>
                    </div>}
                    { data.github_link && <div className="app__project-icon d-flex flex-item-center">
                        <a href={data.github_link} target="_blank" rel="noreferrer">
                            <BsGithub color="#fff" />
                        </a>
                    </div>}
                </div>
                <div className="app__project-textbox">
                    <h4> { data.title }</h4>
                    <p> { data.description } </p>
                    <div className="-tools d-flex">
                        <p> Built with </p>
                        { data.built_with && data.built_with.map(tool => (
                            <p key={tool}> { tool } </p>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Project;